import { trace } from '@opentelemetry/api';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ConsoleSpanExporter, SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { registerInstrumentations } from '@opentelemetry/instrumentation';

let isInitialized = false;

export function initTracing() {
  if (isInitialized) {
    return;
  }

  const isProduction = import.meta.env.MODE === 'production';

  // Only use console exporter in production for debugging
  const spanProcessors = isProduction ? [new SimpleSpanProcessor(new ConsoleSpanExporter())] : [];

  const provider = new WebTracerProvider({
    spanProcessors,
  });

  provider.register();

  const fetchInstrumentation = new FetchInstrumentation({
    propagateTraceHeaderCorsUrls: [
      new RegExp('/api/.*'), // Match relative API URLs
      new RegExp('http://localhost:8080/.*'), // Keep for backward compatibility
    ],
    clearTimingResources: true,
  });

  registerInstrumentations({
    instrumentations: [fetchInstrumentation],
  });

  isInitialized = true;
}

export function getTracer() {
  return trace.getTracer('pgkb-frontend', '1.0.0');
}
